.invoicesTableContainer {
    width: 100%;
  }
  
  .tableTitle {
    font-size: var(--fs-small-heading);
    font-weight: 500;
    color: var(--static-text-strong);
    margin: 0;
  }
  
  .invoiceNumber {
    color: var(--color-primary);
    font-weight: 600;
    cursor: pointer;
    padding: 18px 0;
  }
  
  .paginationContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1rem;
  }
  
  .paginationInfo {
    color: var(--static-text-weak);
    font-size: var(--fs-small);
  }